module.exports = __webpack_public_path__ + "static/img/19012B_0_3_C_20220303_LC.8f5bc42.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/19012B_0_3_C_20220303_LC.png
// module id = QAcU
// module chunks = 0